import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const theMobileInsiderStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white tablet:bg-[#F4F4F5]',
  COMMONS_APPBAR_BG: 'bg-zinc-950',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-zinc-950',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#5B1BFB] [&>svg>path]:!stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#F4F4F5]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#C6FE04]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#5B1BFB] hover:border-[#5B1BFB] hover:bg-[#5B1BFB] text-black hover:text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#C6FE04]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#06071C]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-zinc-950',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-zinc-950',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#06071C]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#5B1BFB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#5B1BFB] text-[#5B1BFB] [&>svg>path]:stroke-[#5B1BFB] [&>svg>g>path]:stroke-[#5B1BFB] [&>svg>path]:fill-[#5B1BFB] [&>svg>g>path]:fill-[#5B1BFB]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#5B1BFB]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-zinc-950',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F4F4F5]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#06071C]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F4F4F5]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-zinc-950 [&>.explore-icon-fill]:!fill-[#F4F4F5] [&>g>.explore-icon-fill]:!fill-[#F4F4F5]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F4F4F5] [&>.vector-top>path]:fill-zinc-950 [&>.vector-bottom>path]:fill-zinc-950',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-orange-400',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#E2E8F0]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-black',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#C6FE04]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-black',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-rose-500',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#06071C]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-blue-100',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: '!text-black',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-indigo-500',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-blue-500',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-blue-500',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-indigo-500',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-white',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-black',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#5B1BFB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#5B1BFB] text-[#5B1BFB] [&>svg>path]:stroke-[#5B1BFB] [&>svg>g>path]:stroke-[#5B1BFB] [&>svg>path]:fill-[#5B1BFB] [&>svg>g>path]:fill-[#5B1BFB]',
  LISTPAGE_BUTTON_LINK: 'text-[#5B1BFB]',
  LISTPAGE_ANCHOR_LINK: 'text-[#5B1BFB]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#5B1BFB]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#5B1BFB]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#5B1BFB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#5B1BFB] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#5B1BFB] text-[#5B1BFB]  [&>svg>path]:stroke-[#5B1BFB] [&>svg>g>path]:stroke-[#5B1BFB] [&>svg>path]:fill-[#5B1BFB] [&>svg>g>path]:fill-[#5B1BFB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#5B1BFB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#5B1BFB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#5B1BFB]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#5B1BFB]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'border-[#5B1BFB]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#5B1BFB]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-indigo-500 [&>.vector-top>path]:fill-indigo-300 [&>.vector-bottom>path]:fill-indigo-100',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100 tablet:bg-[#E2E8F0]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:stroke-green-700 fill-green-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-black data-[focus]:bg-[#D1BFFC]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-white bg-[#5B1BFB]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#5B1BFB]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5] tablet:bg-white',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container-new-layout',
}
